export default function StructuredData({ data }) {
  function unescapeQuotes(str) {
    const quotes = /(&#8220;|&#8221;|&#8243;|&quot;)/g;
    const ampersand = /&#038;/g;
    const replaceQuotesWith = '"';
    const replaceAmpersandsWith = '&';

    const result = str
      .replace(quotes, replaceQuotesWith)
      .replace(ampersand, replaceAmpersandsWith);
    return result;
  }
  const structuredData = unescapeQuotes(data);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={ { __html: structuredData } }
    />
  );
}
